import api from './api';

// Separate from appService.js - release uploads are large (.deb packages,
// 50-300MB) and need upload-progress tracking that nothing else in the
// admin panel currently requires.
export const appReleaseService = {
   addRelease: async (
      appId,
      { version, packageType, architecture, releaseNotes, status, file },
      onUploadProgress
   ) => {
      const formData = new FormData();
      formData.append('version', version);
      if (packageType) formData.append('packageType', packageType);
      if (architecture) formData.append('architecture', architecture);
      if (releaseNotes) formData.append('releaseNotes', releaseNotes);
      if (status) formData.append('status', status);
      formData.append('package', file);

      const response = await api.post(`/apps/${appId}/releases`, formData, {
         headers: { 'Content-Type': 'multipart/form-data' },
         timeout: 15 * 60 * 1000, // 15 min - large packages on slow connections
         onUploadProgress: (event) => {
            if (onUploadProgress && event.total) {
               onUploadProgress(Math.round((event.loaded / event.total) * 100));
            }
         },
      });
      return response.data;
   },

   updateRelease: async (releaseId, data) => {
      const response = await api.put(`/apps/releases/${releaseId}`, data);
      return response.data;
   },

   deleteRelease: async (releaseId) => {
      const response = await api.delete(`/apps/releases/${releaseId}`);
      return response.data;
   },
};
